// Where a message goes: a customer attribute (rendered per customer by Bloomreach) or one fixed test number.

// Jinja-breaking characters for customer['<attr>']: quotes, backslash, braces, percent, line breaks.
const ATTRIBUTE_FORBIDDEN = /['"\\{}%\r\n]/;

export const normalizeAttribute = (value) => {
  const attr = String(value ?? '').trim();
  return attr && attr.length <= 100 && !ATTRIBUTE_FORBIDDEN.test(attr) ? attr : null;
};

// gs-intg passes destination to Enterprise send_to unchanged (send-template.mapper.ts), so digits only.
export const normalizePhoneNumber = (value) => {
  const digits = String(value ?? '').replace(/[\s()+-]/g, '');
  return /^\d{8,15}$/.test(digits) ? digits : null;
};

export const defaultDestination = (phoneAttribute) => ({ type: 'attribute', value: normalizeAttribute(phoneAttribute) || 'phone' });

// Anything missing or invalid (old widget_state, hand-edited state) falls back to the org default.
export const normalizeDestination = (destination, phoneAttribute) => {
  if (destination?.type === 'number') {
    const number = normalizePhoneNumber(destination.value);
    if (number) return { type: 'number', value: number };
  }
  if (destination?.type === 'attribute') {
    const attr = normalizeAttribute(destination.value);
    if (attr) return { type: 'attribute', value: attr };
  }
  return defaultDestination(phoneAttribute);
};

export const isSameDestination = (a, b) => a?.type === b?.type && a?.value === b?.value;

// The Send to box uses the message fields' own token syntax: {customer.phone} or {customer['phone number']}.
// The braces are optional there, and a bare phone number means "send every message to this number".
const ATTRIBUTE_EXPRESSION = /^customer\s*(?:\.\s*([A-Za-z_][A-Za-z0-9_]*)|\[\s*(['"])(.+)\2\s*\])$/;
const SIMPLE_ATTRIBUTE = /^[A-Za-z_][A-Za-z0-9_]*$/;

export const parseDestinationInput = (text) => {
  const raw = String(text ?? '').trim();
  const number = normalizePhoneNumber(raw);
  if (number) return { type: 'number', value: number };
  const expression = raw.startsWith('{') && raw.endsWith('}') ? raw.slice(1, -1).trim() : raw;
  const match = expression.match(ATTRIBUTE_EXPRESSION);
  const attr = match ? normalizeAttribute(match[1] ?? match[3]) : null;
  return attr ? { type: 'attribute', value: attr } : null;
};

export const formatDestination = (destination) => {
  if (destination.type === 'number') return destination.value;
  return SIMPLE_ATTRIBUTE.test(destination.value) ? `{customer.${destination.value}}` : `{customer['${destination.value}']}`;
};
